import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/finish',
      name: 'Finish',
      component: () =>
        import('../views/Finish.vue')
    }
  ]
});

routes.beforeEach((to, from, next) => {
  if (to.path === '/') {
    if (to.query.c) {
      sessionStorage.setItem('cfc', to.query.c);
    }
  } else {
    if (sessionStorage.getItem('cfc') === null) {
      next({ path: '/', query: { c: to.query.c } });
    }
  }
  next();
});

routes.afterEach(() => {
  document.addEventListener('touchstart', function() {}, false);
  document.documentElement.style.setProperty('--vh', window.innerHeight + 'px');
});
export default routes;
